// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { VdcLookupResponseModel } from './vdcLookupResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardV2DebitCardV2VdcLookupDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': VdcLookupResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardV2DebitCardV2VdcLookupDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "VdcLookupResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardV2DebitCardV2VdcLookupDefaultResponse.attributeTypeMap;
    }
}
